import React from 'react';
import { useI18n } from '../contexts/I18nContext';

export function StatusChip({ status, label }) {
  const { t } = useI18n();
  const map = {
    ok: { cls: 'bg-sage-100 text-sage-600 border-sage/20', dot: 'bg-sage-500', text: label || t('status_ok') },
    warning: { cls: 'bg-amber_warn-100 text-[#b4843f] border-amber_warn/20', dot: 'bg-amber_warn', text: label || t('status_warning') },
    critical: { cls: 'bg-terracotta-100 text-terracotta-700 border-terracotta/20', dot: 'bg-terracotta animate-pulse-soft', text: label || t('status_critical') },
    online: { cls: 'bg-sage-100 text-sage-600', dot: 'bg-sage-500', text: t('status_online') },
    offline: { cls: 'bg-stone-100 text-ink-soft', dot: 'bg-ink-muted', text: t('status_offline') },
    never_reported: { cls: 'bg-white text-ink-muted border-dashed !border-stone_line', dot: 'bg-stone_line', text: t('status_never_reported') },
  };
  const s = map[status] || map.ok;
  return (
    <span
      data-testid={`status-chip-${status}`}
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium border border-transparent ${s.cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.text}
    </span>
  );
}

export function SeverityDot({ severity }) {
  const m = {
    info: 'bg-sage-500',
    warning: 'bg-amber_warn',
    critical: 'bg-terracotta animate-pulse-soft',
  };
  return <span className={`w-2 h-2 rounded-full ${m[severity] || m.info}`} />;
}
